'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PushAutomaticGift = function () {
  function PushAutomaticGift() {
    (0, _classCallCheck3.default)(this, PushAutomaticGift);

    this.dataElements = document.querySelectorAll('[data-automatic-gifting-el]');
  }

  (0, _createClass3.default)(PushAutomaticGift, [{
    key: 'isEligible',
    value: function isEligible() {
      return this.dataElements.length > 0;
    }
  }, {
    key: 'getProductsToAddRemove',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _ref2, cartTotal, cartItems, subtotalElement, match, currencySymbol, removes, adds, productsToRemove, productsToAdd, validProductsToAdd;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getCartInfo();

              case 2:
                _ref2 = _context.sent;
                cartTotal = _ref2.cartTotal;
                cartItems = _ref2.cartItems;
                subtotalElement = document.querySelector('[data-pushcart-total]');

                if (subtotalElement != null) {
                  match = subtotalElement.innerText.match(/[^0-9.,]/g) || [];
                  currencySymbol = match.join('');


                  document.querySelector('[data-pushcart-total]').innerText = '' + currencySymbol + (cartTotal / 100).toFixed(2);
                }

                removes = [];
                adds = [];

                // Process data elements

                if (this.dataElements.length > 0) {
                  this.processDataElements(this.dataElements, cartTotal, cartItems, adds, removes);
                }

                // Prepare data for cart processing
                productsToRemove = removes.map(function (data) {
                  var variantId = Number(data.dataset.variantId);
                  var item = cartItems.find(function (item) {
                    return item.variant_id === variantId && item.properties && item.properties._automatic_gift === 'true';
                  });
                  return {
                    key: item.key,
                    variantId: variantId
                  };
                });
                productsToAdd = adds.map(function (data) {
                  var properties = (0, _defineProperty3.default)({
                    _automatic_gift: 'true' }, data.dataset.productMessageLabel, data.dataset.productMessage);

                  // Make sure we always have a valid number for the variant ID
                  var variantId = Number(data.dataset.variantId);
                  if (isNaN(variantId) || variantId <= 0) {
                    return null;
                  }

                  return {
                    id: variantId,
                    quantity: 1,
                    properties: properties
                  };
                });

                // Filter out any null products (invalid variant IDs)

                validProductsToAdd = productsToAdd.filter(function (product) {
                  return product !== null;
                });
                return _context.abrupt('return', { productsToAdd: validProductsToAdd, productsToRemove: productsToRemove });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProductsToAddRemove() {
        return _ref.apply(this, arguments);
      }

      return getProductsToAddRemove;
    }()
  }, {
    key: 'processDataElements',
    value: function processDataElements(elements, cartTotal, cartItems, adds, removes) {
      // Get cookie that tracks if user has removed gifts
      var gwpRemovedCookie = _jsCookie2.default.get('gwpRemoved-1');

      // Create an array of all variant IDs in the cart
      var cartVariantIds = cartItems.map(function (item) {
        return item.variant_id;
      });

      elements.forEach(function (data) {
        // Ensure variantId is parsed correctly as a number
        var rawVariantId = data.dataset.variantId;
        var variantId = Number(rawVariantId);

        var minCartValue = Number(data.dataset.minCartValue);
        var maxCartValue = Number(data.dataset.maxCartValue || 9999999);
        var mandatoryIdsString = data.dataset.mandatoryVariantIds || '';
        var mandatoryIds = mandatoryIdsString.split(',').map(function (str) {
          return Number(str.trim());
        }).filter(function (num) {
          return !isNaN(num);
        });

        // Mandatory variant ID checking
        var mandatoryOk = void 0;
        if (mandatoryIds.length > 0 && mandatoryIdsString !== '') {
          // If mandatory IDs are specified, at least one must be in the cart
          mandatoryOk = cartVariantIds.some(function (id) {
            return mandatoryIds.includes(id);
          });

          // If the mandatory items are in the cart, clear any gwp cookie to ensure gifts can be added
          if (mandatoryOk) {
            // Check if any of the mandatory variants are in the cart
            var rulesVariantInCart = mandatoryIds.some(function (id) {
              return cartVariantIds.includes(id);
            });

            if (rulesVariantInCart && gwpRemovedCookie) {
              _jsCookie2.default.remove('gwpRemoved-1');
            }
          }
        } else {
          // If no mandatory IDs are specified, any product qualifies
          mandatoryOk = true;
        }

        // Check if this gift has been removed by the user
        // Handle both scenarios: cookie="true" (all gifts disabled) or comma-separated variant IDs
        if (gwpRemovedCookie === 'true' || gwpRemovedCookie && gwpRemovedCookie.includes(String(variantId))) {
          return;
        }

        // Check if gift is already in cart
        var matchingItems = [];
        try {
          if (cartItems && cartItems.length > 0) {
            matchingItems = cartItems.filter(function (item) {
              var isMatchingVariant = item.variant_id === variantId;
              var hasProperties = item.properties !== null && item.properties !== undefined;
              var isAutomaticGift = hasProperties && item.properties._automatic_gift === 'true';

              return isMatchingVariant && hasProperties && isAutomaticGift;
            });
          }
        } catch (err) {
          console.error('Error during cart item filtering:', err);
        }

        var inCart = matchingItems.length > 0;

        // Step 1: Check if we need to skip processing entirely
        if (mandatoryIds.length > 0 && !mandatoryOk && !inCart) {
          // Only skip if mandatory variants are specified, not satisfied, and gift not already in cart
          return;
        }

        // Step 2: Check if the gift needs to be removed
        if ((cartTotal < minCartValue || cartTotal > maxCartValue || !mandatoryOk) && inCart) {
          removes.push(data);
        }
        // Step 3: Check if the gift needs to be added
        else if (cartTotal >= minCartValue && cartTotal <= maxCartValue && mandatoryOk && !inCart) {
            // Add to the adds array
            try {
              adds.push(data);
            } catch (err) {
              console.error('Error adding gift to array:', err);
            }
          }
      });
    }
  }, {
    key: 'getCartInfo',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var cart, cartTotal, cartItems;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetch('/cart.js').then(function (res) {
                  return res.json();
                });

              case 3:
                cart = _context2.sent;
                cartTotal = cart.items.reduce(function (total, item) {
                  var keys = Object.keys(item.properties || {});
                  if (!keys.includes('_automatic_gift')) {
                    return total + item.final_line_price;
                  } else {
                    return total;
                  }
                }, 0);
                cartItems = cart.items || [];
                return _context2.abrupt('return', { cartTotal: cartTotal, cartItems: cartItems });

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.error('Error fetching cart total:', _context2.t0.message);
                return _context2.abrupt('return', { cartTotal: 0, cartItems: [] });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function getCartInfo() {
        return _ref3.apply(this, arguments);
      }

      return getCartInfo;
    }()
  }]);
  return PushAutomaticGift;
}(); /* eslint-disable */


exports.default = PushAutomaticGift;